<template>
	<inertia-head title="Events" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Upcoming Events</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Upcoming Events Management List</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<h5>
			<div class="form-check form-switch form-check-inline">
				<input
					class="form-check-input"
					type="checkbox"
					:value="form.filter"
					:id="form.filter"
					name="filter"
					:checked="form.filter"
					@change="searchEvents()"
				/>
				<label class="form-check-label fw-semibold" for="filter">
					{{ form.filter==0 ? 'PAST EVENT' : 'UPCOMING' }}
				</label>
			</div>
		</h5>
		<div class="block border-bottom">
			<div class="block-content">
				<form @submit.prevent="searchEvents">
					<div class="row">
						<div class="col-md-10 mb-4">
							<div class="input-group">
								<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
								<span class="input-group-btn">
									<button
										type="submit"
										class="btn btn-secondary"
										:disabled="!form.isDirty || form.processing"
									>
										<i class="fa fa-search me-1"></i>Display
									</button>
								</span>
							</div>
						</div>
						<div class="col space-x-1 mb-4 text-end">
							<button
								@click="addEvent"
								type="button"
								class="btn btn-info"
							>
								<i class="fa fa-plus me-1"></i>Add
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<pagination :collections="events" />
		<div v-for="(event,v_index) in events.data" class="block mb-1" :class="{'border-start border-success border-5':event.is_featured==1}">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-md-3">
						<img :src="event.event_image_url??'/media/images/event_image.jpeg'" style="width:100%"/>
					</div>
					<div class="col-md-9">
						<p class="m-0"><span class="fw-bold">{{event.title}}</span>
							<span v-if="event.is_featured==1" class="badge bg-warning fw-normal fs-xs ms-2">Featured</span>
						</p>
						<div class="fs-sm fw-normal text-muted mb-2">
							<span class="me-3">
								<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
								{{ event.event_datetime_display }}
							</span>

							<div class="form-check form-switch form-check-inline">
								<input
									class="form-check-input"
									type="checkbox"
									:value="event.is_active"
									:id="event.id"
									name="example-switch-inline1"
									:checked="event.is_active"
									@change="toggleStatus(event.upcoming_event_uuid,event.is_active)"
								/>
								<label class="form-check-label fw-semibold" :for="event.id">
									{{ event.is_active ? 'ACTIVE' : 'IN-ACTIVE' }}
								</label>
							</div>
						</div>
						<div>{{event.location}}</div>
						<div class="mt-5 fw-bold">Total Notifications: {{event.total_notifications}}</div>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full block-content-sm bg-body-light fs-sm space-x-1">
				<button @click="updateEvent(v_index)" type="button" class="btn btn-outline-info btn-sm"><i class="fa fa-edit me-1"></i>Edit</button>
				<button @click="selectDeleteEvent(event.upcoming_event_uuid)" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-1"></i>Delete</button>
				<button v-if="event.event_link==null || event.is_active==0" type="button" class="btn btn-outline-success btn-sm me-1 disabled" title="Disabled Notifications"><i class="fa fa-envelope me-1"></i>Send Notifications</button>
				<span v-if="event.event_link!=null && event.is_active==1">
					<button @click="notifyAttendee(event.upcoming_event_uuid,v_index)" :disabled="formNotify.processing && selected_index==v_index" type="button" class="btn btn-outline-success btn-sm me-1">
						<div
							v-if="formNotify.processing && selected_index==v_index"
							class="spinner-border spinner-border-sm text-dark me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<i v-else class="fa fa-envelope me-1"></i>
						Send Notifications
					</button>
				</span>
			</div>
		</div>
		<div v-if="events.data.length==0" class="block mb-1">
			<div class="block-content block-content-full">
				<h1 class="text-center text-danger">No Upcoming Event Found</h1>
			</div>
		</div>
		<div class="mt-3">
			<pagination :collections="events" />
		</div>
	</div>


	<modal ref="deleteModal" size="modal-md">
		<template #title>
			Delete Confirmation
		</template>
		<template #body>
			<div class="mb-4">
				<p class="h5">Are you sure, you want to delete this details?</p>
			</div>
		</template>
		<template #footer>
			<button @click="confirmDeleteEvent" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
			<button type="button" class="btn btn-sm btn-secondary" @click="deleteModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>

	<AddUpdateUpcomingEventModal
			key="EventModal"
			ref="addUpdateUpcomingEventModal"
		/>

</template>

<script>
	import { onMounted, watch, ref, reactive } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import AuthLayout from '../../Layouts/AuthLayout';
	import { createToaster } from '@meforma/vue-toaster';
	import { Inertia } from '@inertiajs/inertia';
	import AddUpdateUpcomingEventModal from '../../Components/Admin/AddUpdateUpcomingEventModal'

	export default{
		layout: AuthLayout,
		props: {
			events				: Object,
			filter				: String,
			search				: String,
			errors				: Object,
			api_response 		: Object,
			flash				: Object
		},
		components:{AddUpdateUpcomingEventModal},
		setup(props){

			const deleteModal = ref(null);

			const selected_index = ref(null);

			const selected_event_uuid = ref(null);

			const toast = createToaster();

			const action = ref('add');

			const formNotify = useForm({
				upcoming_event_uuid: ''
			});

			const form = useForm({
							filter 		: props.filter,
							search 		: props.search,
							is_active 	: 0,
						})

			const addUpdateUpcomingEventModal = ref(null);

			const searchEvents = () => {

				if(form.filter==1)
				{
					form.filter=0;
				}else
				{
					form.filter=1;
				}

				Inertia.get(route('admin.upcoming-events',{
						filter 		: form.filter,
						search 		: form.search
					})
				)
			}


			const toggleStatus = (_event_uuid,is_active)=>{
									action.value = "update";
									form.is_active = (is_active==1) ? 0 : 1;
									form.put('upcoming-events/status/'+_event_uuid, {
										preserveState: true,
										preserveScroll: true,
										only:['events,api_response'],
									})
								}

			const addEvent = ()=>{

								action.value = "add";
								addUpdateUpcomingEventModal.value.setUpcomingEventContent(action.value,null);
								addUpdateUpcomingEventModal.value.toggleModal();
							}

			const updateEvent = (_index)=>{

									action.value = "update";

									addUpdateUpcomingEventModal.value.setUpcomingEventContent(action.value,props.events.data[_index]);

									addUpdateUpcomingEventModal.value.toggleModal();
								}

			const selectDeleteEvent = (_event_uuid)=>{
										selected_event_uuid.value = _event_uuid;
										deleteModal.value.toggleModal();
									}

			const confirmDeleteEvent = ()=>{
										deleteEvent(selected_event_uuid.value);
									}

			const deleteEvent = (_event_uuid) => {
									action.value = "delete";
									Inertia.delete('upcoming-events/'+_event_uuid,
									{
										preserveState: true,
										preserveScroll: true,
										only:['events','api_response'],
										onSuccess:()=> {
											selected_event_uuid.value = null;
											deleteModal.value.toggleModal();
										}
									})
								}

			const notifyAttendee = (_event_uuid,_index)=>{
				formNotify.upcoming_event_uuid = _event_uuid;
				selected_index.value = _index;
				formNotify.post(route("admin.post.upcoming-events-send-notifications"),{
					preserveState: true,
					preserveScroll: true,
					only:['events','api_response','flash'],
				})

			}

			watch(()=>props.api_response, (value) => {
			
				if(value!=null)
				{
					var action_msg = action.value=='add'?'added':(action.value=='update'?'updated':'deleted'); 

					if(value.result=="success")
					{
						toast.show("Successfully "+action_msg, { type: value.result});
					}else
					{
						toast.show("Failed to process", { type: "error"});
					}
				}
			})


			return{
				selected_index,
				formNotify,
				selected_event_uuid,
				selectDeleteEvent,
				deleteModal,
				confirmDeleteEvent,
				toast,
				action,
				form,
				toggleStatus,
				searchEvents,
				addUpdateUpcomingEventModal,
				addEvent,
				updateEvent,
				deleteEvent,
				notifyAttendee
			}

		}
	}

</script>